/** @jsxImportSource @emotion/react */
import { FC } from 'react'
import { css } from '@emotion/react'
import { observer } from 'mobx-react-lite'
import { BoxStore } from '../../stores/RussianPoker/Box.store'
import { ContainerWrapper, Container } from './styles'
import { BetsDataView } from '../BetsDataView'
import { TotalDepositBox } from '../TotalDepositBox'
import { CloseBtn } from '../CloseBtn'

export const StakedBoxView: FC<{ box: BoxStore }> = observer((props) => {
  const { sumStake, sendRollbackAllStakes } = props.box

  return (
    <ContainerWrapper>
      <Container>
        <div
          css={css`
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 2px;
          `}>
          <TotalDepositBox
            deposit={sumStake}
            css={css`
              padding-bottom: 0;
            `}
          />
          <CloseBtn
            circle
            onClick={(event) => {
              event.stopPropagation()
              event.preventDefault()

              sendRollbackAllStakes()
            }}
          />
        </div>
        <BetsDataView box={props.box} isInteractive={false} />
      </Container>
    </ContainerWrapper>
  )
})
